var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "cof-field",
      class: { padingless: _vm.noStyle || _vm.noMargin, error: _vm.hasError }
    },
    [
      !_vm.noStyle && _vm.label
        ? _c("label", [
            _vm._v(_vm._s(_vm.label) + ": "),
            _vm.isRequired
              ? _c("span", { staticClass: "required" }, [_vm._v("*")])
              : _vm._e()
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm._t("default"),
      _vm._v(" "),
      !_vm.noStyle && _vm.validator
        ? _c(
            "span",
            { staticClass: "errors" },
            _vm._l(_vm.errors, function(error) {
              return _c(
                "span",
                { key: error, staticClass: "help-block text-danger" },
                [_vm._v(_vm._s(error))]
              )
            }),
            0
          )
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }